export const Text = {
  baseStyle: {
    mb: 0,
    lineHeight: '1.7',
  },

  variants: {
    tiny_uppercase: {
      fontSize: 'xxs',
      fontWeight: 'bold',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
    },
    line_height_medium: {
      lineHeight: '27.01px',
    },
  },
};
